export default __webpack_public_path__ + "static/media/entrevistas.2ad6ad18.png";